import { all, call, put, takeLatest } from "redux-saga/effects";
import { request } from "@app/services";

import * as endpoints from "./endpoints";
import {
  beAnInvestor,
  beAnInvestorFailed,
  beAnInvestorSuccess,
  verifyInvestor,
  verifyInvestorFailed,
  verifyInvestorSuccess,
} from "./slices";

//--------------------GetAllBrands-------------------------

function* beAnInvestorSaga({ payload }: ReturnType<typeof beAnInvestor>): any {
  try {
    const { firstName, lastName, email, phone, state, city, zipCode } = payload as any;

    const response = yield call(request.post, endpoints.BeAnInvestor, {
      firstName,
      lastName,
      email,
      phone,
      state,
      city,
      zipCode,
    });

    if (response?.alreadyExists) {
      yield put(
        beAnInvestorSuccess({
          message: "User with same email or phone number already exists",
          alreadyExists: true,
        }),
      );
      return;
    }
    console.log("response>>>", response);

    yield put(
      beAnInvestorSuccess({
        data: response.data,
        message: response.message,
        requiresOtp: response.requiresOtp,
        orderId: response.orderId,
      }),
    );
  } catch (error: any) {
    yield put(
      beAnInvestorFailed({
        message: error?.message || "Something went wrong",
      }),
    );
  }
}

function* verifyInvestorSaga({
  payload,
}: ReturnType<typeof verifyInvestor>): any {
  try {
    const { firstName, lastName, email, phone, otp, orderId } = payload;

    const response = yield call(request.post, endpoints.VerifyInvestor, {
      firstName,
      lastName,
      email,
      phone,
      otp,
      orderId,
    });

    yield put(
      verifyInvestorSuccess({
        data: response?.data,
        message: response?.message,
      }),
    );
  } catch (error: any) {
    yield put(
      verifyInvestorFailed({
        message: error?.message || "Something went wrong",
      }),
    );
  }
}

function* beAnInvestorSagas() {
  yield all([
    takeLatest(beAnInvestor, beAnInvestorSaga),
    takeLatest(verifyInvestor, verifyInvestorSaga),
  ]);
}

export { beAnInvestorSagas };
